/* ==========================================================================
   Royal Care Professional — social click tracking

   Every social icon carries data-rc-social (the network) and
   data-rc-social-placement (sticky_bar, footer_brand, footer_contact or
   contact_page). A click on one is published as the custom event
   rc_social_click, with { network, placement, url }.

   Published rather than sent to gtag, because Google Ads and GA4 reach this
   store through the Google & YouTube app's web pixel. That pixel runs in
   Shopify's sandbox and never sees a click on the page, and there is no gtag
   on the page itself to call. Shopify.analytics.publish is the way into the
   sandbox: a custom pixel subscribed to rc_social_click (Settings > Customer
   events) forwards it to Google.

   One delegated listener on the document, so icons the theme editor
   re-renders need no setup.
   ========================================================================== */

(function () {
  'use strict';

  if (window.RCSocialTracking) return;
  window.RCSocialTracking = true;

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-rc-social]');
    if (!link) return;

    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;

    analytics.publish('rc_social_click', {
      network: link.dataset.rcSocial,
      placement: link.dataset.rcSocialPlacement,
      url: link.href
    });
  });
})();
